import { render } from "./FullDayTrainingView.vue?vue&type=template&id=25ce3223"
import script from "./FullDayTrainingView.vue?vue&type=script&lang=js"
export * from "./FullDayTrainingView.vue?vue&type=script&lang=js"

import exportComponent from "/home/misha/Рабочий стол/sparta-system-front-trainer/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__